import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../../Redux/hooks";
import SideBar from "../../../Components/FeedComponents/SideBar/SideBar";
import TopBar from "../../../Components/FeedComponents/TopBar/TopBar";
import "./page-container.css";

type propsType = {
  children: any;
  title: string;
  pl?: string;
  pt?: string;
};

const PageContainer = ({ children, title, pl, pt = "0px" }: propsType) => {
  const sidebarState = useAppSelector((state) => state.sidebarState);
  const [isMobile, setIsMobile] = useState(false);

  // Check window width on mount and resize
  useEffect(() => {
    const checkWidth = () => {
      setIsMobile(window.innerWidth < 768); // 768px is typical mobile breakpoint
    };

    // Check on mount
    checkWidth();

    // Add event listener
    window.addEventListener("resize", checkWidth);

    // Cleanup
    return () => window.removeEventListener("resize", checkWidth);
  }, []);

  // Determine if sidebar should be expanded based on state and screen size
  const shouldShowExpandedSidebar = sidebarState && !isMobile;

  return (
    <div className="HomeContainer2">
      {shouldShowExpandedSidebar ? (
        <div className="LeftContainer">
          <SideBar />
        </div>
      ) : (
        <div className="LeftContainerClose">
          <SideBar />
        </div>
      )}
      <div className="page-container-right">
        <div>
          <TopBar title={title} />
          <div style={{ paddingLeft: pl, paddingTop: pt }}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default PageContainer;
